import { render, staticRenderFns } from "./GBBar.vue?vue&type=template&id=c3937630&scoped=true&"
import script from "./GBBar.vue?vue&type=script&lang=js&"
export * from "./GBBar.vue?vue&type=script&lang=js&"
import style0 from "./GBBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GBBar.vue?vue&type=style&index=1&id=c3937630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3937630",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
